// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';

// Others
import noteApi from '~/apis/note';
import { IFormNote } from '~/utils/interface/note';
import { CREATE_NOTE } from '~/utils/constants/actionType';

export const createNote = createAsyncThunk(CREATE_NOTE, async (body: IFormNote, { rejectWithValue }) => {
  try {
    const resp = await noteApi.createNote(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
